import Description from "material-design-icons/action/svg/production/ic_description_24px.svg";
import DirectionsTransit from "material-design-icons/maps/svg/production/ic_directions_transit_24px.svg";
import Forum from "material-design-icons/communication/svg/production/ic_forum_24px.svg";
import LocalActivity from "material-design-icons/maps/svg/production/ic_local_activity_24px.svg";
import LocalBar from "material-design-icons/maps/svg/production/ic_local_bar_24px.svg";
import LocalHotel from "material-design-icons/maps/svg/production/ic_local_hotel_24px.svg";
import LocalMall from "material-design-icons/maps/svg/production/ic_local_mall_24px.svg";
import LocalMovies from "material-design-icons/maps/svg/production/ic_local_movies_24px.svg";
import Map from "material-design-icons/maps/svg/production/ic_map_24px.svg";
import PhotoCamera from "material-design-icons/image/svg/production/ic_photo_camera_24px.svg";
import Public from "material-design-icons/social/svg/production/ic_public_24px.svg";
import Restaurant from "material-design-icons/maps/svg/production/ic_restaurant_24px.svg";

export default {
  Description,
  DirectionsTransit,
  Forum,
  LocalActivity,
  LocalBar,
  LocalHotel,
  LocalMall,
  LocalMovies,
  Map,
  PhotoCamera,
  Public,
  Restaurant,
};
